import script from "./2.vue?vue&type=script&lang=ts"
export * from "./2.vue?vue&type=script&lang=ts"

import "./2.vue?vue&type=style&index=0&id=48d08d50&lang=css"

export default script